<template>
    <base-auth>
        <div v-if="error_message != ''" style="margin-top: 20px">
            <div class="alert alert-danger text-white fade show mx-auto w-75">
                <span v-html="error_message"></span>
            </div>
        </div>
        <template v-slot:tabs>
            <div class="auth-tabs-switch" role="tablist">
                <router-link to="/login" class="auth-tab">ورود</router-link>
                <router-link to="/register" class="auth-tab"
                    >ثبت‌نام</router-link
                >
            </div>
        </template>
        <form @submit.prevent="onSubmit" class="mt-1">
            <vue-recaptcha
                v-if="captchaDriver === 'recaptcha'"
                ref="invisibleRecaptcha"
                @verify="onVerify"
                @expired="onExpired"
                size="invisible"
                :sitekey="sitekey"
                :loadRecaptchaScript="true"
            >
            </vue-recaptcha>
            <arcaptcha-vue
                v-if="captchaDriver === 'arcaptcha'"
                ref="arcaptcha"
                :site_key="arCaptchaKey"
                :invisible="true"
                :callback="onArcaptchaSuccess"
                :expired_callback="onArcaptchaExpired"
                :error_callback="onArcaptchaError"
            />
            <div class="card-login-register w-75 pt-2 pb-3">
                <div class="login-form login-form-register">
                    <div class="flex-column px-5 pt-3">
                        <div>
                            <div>
                                <div class="d-flex align-items-center">
                                    <input
                                        type="radio"
                                        name="type-account"
                                        class="type-account-radio"
                                        @click="is_real_user = true"
                                    />
                                    <span class="font-weight-bold mr-2"
                                        >حساب حقیقی</span
                                    >
                                </div>
                                <!-- <div>
                                  <p class="pt-1 text-right">
                                    برای ایجاد حساب حقیقی روی این دکمه کلیک کنید
                                  </p>
                                </div> -->
                            </div>
                        </div>
                        <div class="mt-3">
                            <div>
                                <div class="d-flex align-items-center">
                                    <input
                                        type="radio"
                                        name="type-account"
                                        class="type-account-radio"
                                        @click="is_real_user = false"
                                    />
                                    <span class="font-weight-bold mr-2"
                                        >حساب حقوقی</span
                                    >
                                </div>
                                <!-- <div>
                                  <p class="pt-1 text-right pr-2">
                                    برای ایجاد حساب از نوع حقوقی اینجا کلیک کنید
                                  </p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="is_real_user !== null">
                    <div
                        v-if="is_real_user"
                        class="form-field form-field-register"
                    >
                        <input
                            type="text"
                            :placeholder="$t('auth.placeholder.first_name')"
                            name="first_name"
                            v-model="first_name"
                        />
                    </div>
                    <div
                        v-if="is_real_user"
                        class="form-field form-field-register"
                    >
                        <input
                            type="text"
                            :placeholder="$t('auth.placeholder.last_name')"
                            name="last_name"
                            v-model="last_name"
                        />
                    </div>
                    <div
                        v-if="!is_real_user"
                        class="form-field form-field-register"
                    >
                        <input
                            type="text"
                            :placeholder="$t('label.com_name_fa')"
                            name="com_name_fa"
                            v-model="com_name_fa"
                        />
                    </div>
                    <div class="form-field form-field-register">
                        <input
                            type="text"
                            :placeholder="$t('auth.placeholder.phone')"
                            name="phone"
                            v-model="phone"
                            id="phone"
                        />
                    </div>
                    <div class="form-field form-field-register">
                        <input
                            type="password"
                            placeholder="رمز عبور"
                            name="password"
                            autocomplete="off"
                            v-model="password"
                        />
                    </div>
                    <div class="form-link" style="width: auto">
                        <div class="mb-4" style="width: auto">
                            <label class="px-2">
                                <kt-form-check
                                    id="agree"
                                    name="agree"
                                    v-model="agree"
                                >
                                </kt-form-check>
                                <a
                                    class="text-primary"
                                    href="https://paystar.ir/terms"
                                    target="_blank"
                                >
                                    {{
                                        $t(
                                            'auth.im_agree_with_terms_and_condition'
                                        )
                                    }}
                                </a>
                            </label>
                        </div>
                    </div>
                    <div class="login-footer login-footer-register">
                        <input
                            v-if="!loading"
                            type="submit"
                            id="login_signup_submit"
                            value="ثبت نام"
                        />
                        <button
                            v-else
                            disabled
                            type="button"
                            class="btn btn-success btn-block"
                        >
                            <span class="spinner-border"></span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="login-paylane" aria-hidden="true">
            <div
                class="paylane-node paylane-node--1"
                :class="paylaneNodeClass(1)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="8" r="3.5" /><path d="M5 19.5c0-3.6 3.1-5.5 7-5.5s7 1.9 7 5.5" />
                </svg>
            </div>
            <span class="paylane-link" :class="paylaneLinkClass(1)"
                ><i class="paylane-dot"></i
            ></span>
            <div
                class="paylane-node paylane-node--2"
                :class="paylaneNodeClass(2)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="5" y="3.5" width="14" height="17" rx="2" /><path d="M8.5 8h7" /><path d="M8.5 12h7" /><path d="M8.5 16h4" />
                </svg>
            </div>
            <span class="paylane-link" :class="paylaneLinkClass(2)"
                ><i class="paylane-dot"></i
            ></span>
            <div
                class="paylane-node paylane-node--3"
                :class="paylaneNodeClass(3)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 2.5l7 2.7v5.6c0 4.3-3 8.2-7 9.7-4-1.5-7-5.4-7-9.7V5.2z" /><path d="M9 11.8l2.2 2.2 4-4" />
                </svg>
            </div>
            <span class="paylane-link" :class="paylaneLinkClass(3)"
                ><i class="paylane-dot"></i
            ></span>
            <div
                class="paylane-node paylane-node--4"
                :class="paylaneNodeClass(4)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="7" y="2.5" width="10" height="19" rx="2" /><path d="M10 11.5l2 2 3.5-3.5" />
                </svg>
            </div>
        </div>
    </base-auth>
</template>

<script>
import baseAuth from '@/components/base-auth';
import { KTApp } from '@/plugins/core/app';
import $ from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import { blackList } from '../constants/securityStatus';
import { userTypes, userTypesStr } from '@/constants/userTypes';
import { i18n } from '@/plugins/i18n';
import VueRecaptcha from 'vue-recaptcha';
import { reCaptchaKeys } from '@/constants/getRecaptchaKey';
import { arCaptchaKeys } from '@/constants/getArCaptchaKey';
import { getCaptchaDriver } from '@/constants/getCaptchaDriver';
import ArcaptchaVue from 'arcaptcha-vue';

export default {
    components: {
        'base-auth': baseAuth,
        'vue-recaptcha': VueRecaptcha,
        ArcaptchaVue
    },
    data() {
        return {
            user_types: userTypes,
            user_types_str: userTypesStr,
            com_name_fa: '',
            is_real_user: null,
            first_name: '',
            last_name: '',
            phone: '',
            password: '',
            login_event: null,
            agree: false,
            recaptcha_verified: false,
            g_recaptcha_response: '',
            sitekey: reCaptchaKeys,
            arCaptchaKey: arCaptchaKeys,
            captchaDriver: getCaptchaDriver,
            arcaptchaToken: '',
            arcaptchaVerified: false,
            error_message: '',
            loading: false,
            register_succeeded: false
        };
    },
    computed: {
        ...mapActions('auth', ['sendVerifyStatus']),
        paylane_step() {
            if (this.register_succeeded) return 4;
            if (this.loading) return 3;
            if (this.is_real_user !== null) return 2;
            return 1;
        }
    },
    mounted() {
        setTimeout(() => {
            $('.kt-selectpicker').selectpicker({
                size: 2,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        }, 1000);
    },
    methods: {
        paylaneNodeClass(n) {
            return {
                'is-active': this.paylane_step === n,
                'is-done': this.paylane_step > n,
                'is-dim': this.paylane_step < n
            };
        },
        paylaneLinkClass(n) {
            return {
                'is-done': this.paylane_step > n,
                'is-running': this.paylane_step === n,
                'is-dim': this.paylane_step < n
            };
        },
        onSubmit(e) {
            this.login_event = e;
            this.executeCaptcha();
        },
        async executeCaptcha() {
            this.loading = true;
            if (this.captchaDriver === 'recaptcha') {
                await this.$refs.invisibleRecaptcha.execute();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
                await this.$refs.arcaptcha.execute();
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                this.register(this.login_event);
            }
        },
        onArcaptchaSuccess(token) {
            this.arcaptchaToken = token;
            this.arcaptchaVerified = true;
            this.register(this.login_event);
        },
        onArcaptchaExpired() {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.loading = false;
        },
        onArcaptchaError(error) {
            this.arcaptchaVerified = false;
            this.arcaptchaToken = '';
            this.loading = false;
            this.showMsg(
                $('.kt-form'),
                'danger',
                'Captcha verification failed. Please try again.'
            );
        },
        isCaptchaVerified() {
            if (this.captchaDriver === 'recaptcha') {
                return this.recaptcha_verified;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaVerified && this.arcaptchaToken;
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                return true;
            }
            return false;
        },
        getCaptchaResponse() {
            if (this.captchaDriver === 'recaptcha') {
                return this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                return this.arcaptchaToken;
            } else if (!this.captchaDriver || this.captchaDriver === 'none') {
                return '';
            }
            return '';
        },
        resetCaptcha() {
            if (this.captchaDriver === 'recaptcha') {
                this.$refs.invisibleRecaptcha &&
                    this.$refs.invisibleRecaptcha.reset();
            } else if (this.captchaDriver === 'arcaptcha') {
                this.$refs.arcaptcha && this.$refs.arcaptcha.reset();
                this.arcaptchaVerified = false;
                this.arcaptchaToken = '';
            }
        },
        register(e) {
            if (!this.isCaptchaVerified()) {
                this.loading = false;
                return;
            }

            let form = $(e.target);
            let btn = $('#login_signup_submit');

            form.validate({
                ignore: '.ignore',
                rules: {
                    com_name_fa: {
                        required: () => {
                            return !this.is_real_user;
                        }
                    },
                    first_name: {
                        required: () => {
                            return this.is_real_user;
                        }
                    },
                    last_name: {
                        required: () => {
                            return this.is_real_user;
                        }
                    },
                    password: {
                        required: true
                    },
                    phone: {
                        required: true
                    },
                    agree: {
                        required: true
                    }
                }
            });

            if (!form.valid()) {
                this.loading = false;
                return;
            }

            let referer = null;
            if (this.getCookie('referer_id')) {
                referer = this.getCookie('referer_id');
            }

            let params = {
                user_type: this.is_real_user
                    ? this.user_types.REAL
                    : this.user_types.LEGAL,
                com_name_fa: this.com_name_fa,
                first_name: this.first_name,
                last_name: this.last_name,
                phone: this.phone,
                password: this.password,
                agree: this.agree,
                referer_id: referer
            };

            // Add captcha response based on driver
            if (this.captchaDriver === 'recaptcha') {
                params['g-recaptcha-response'] = this.g_recaptcha_response;
            } else if (this.captchaDriver === 'arcaptcha') {
                params['g-recaptcha-response'] = this.arcaptchaToken;
            }

            KTApp.progress(btn);

            this.$store
                .dispatch('auth/register', params)
                .then((response) => {
                    if (response.status === blackList.FORBIDDEN) {
                        this.showMsg(form, 'danger', response.message);
                        return;
                    }
                    this.$store.dispatch('auth/setRegisterData', params);
                    // this.sendVerify(e)
                    this.register_succeeded = true;
                    setTimeout(() => this.$router.push('/verifyRegister'), 900);
                })
                .catch((response) => {
                    form.validate().showErrors(response.data.data);
                    this.showMsg(form, 'danger', response.data.message);
                    this.resetCaptcha();
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                    this.loading = false;
                    this.resetRecaptcha();
                });
        },
        getCookie(name) {
            let cookieName = name + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookieArray = decodedCookie.split(';');
            for (let i = 0; i < cookieArray.length; i++) {
                while (cookieArray[i].charAt(0) === ' ') {
                    cookieArray[i] = cookieArray[i].substring(1);
                }
                if (cookieArray[i].indexOf(cookieName) === 0) {
                    return cookieArray[i].substring(
                        cookieName.length,
                        cookieArray[i].length
                    );
                }
            }
            return '';
        },
        sendVerify(e) {
            let btn = $(e.target);
            let form = $('.kt-form');
            let phone = $('#phone');

            let params = {
                phone: phone.val()
            };

            KTApp.progress(btn);
            this.$store
                .dispatch('auth/sendVerifyRegister', params)
                .then((response) => {
                    this.showMsg($('.kt-form'), 'success', response.message);
                    this.sent = true;
                    this.sendVerifyStatus;
                })
                .catch((response) => {
                    this.showMsg($('.kt-form'), 'danger', response.message);
                })
                .finally(() => {
                    KTApp.unprogress(btn);
                    this.loading = false;
                });
        },
        onVerify(response) {
            this.recaptcha_verified = true;
            this.g_recaptcha_response = response;
            this.register(this.login_event);
        },
        onExpired() {
            this.recaptcha_verified = false;
            this.loading = false;
        },
        showMsg(form, type, message) {
            this.error_message = message;
        }
    }
};
</script>

<style scoped>
.kt-checkbox {
    direction: rtl !important;
}
ul {
    list-style: none;
}
ul li {
    cursor: pointer;
    font-weight: bold;
    font-size: 1.2rem;
}
li a:hover {
    color: #00bea5 !important;
}
.type-account-radio {
    width: 18px;
    height: 18px;
    accent-color: #00bea5;
    cursor: pointer;
}
::placeholder {
    padding-right: 5px;
}

/* سیر ثبت‌نام — همگام با مرحله جاری */
.login-paylane {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75%;
    margin: 26px auto 6px;
}
.paylane-node {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: transparent;
    border: 1px solid rgba(0, 190, 165, 0.35);
    color: #00bea5;
    opacity: 0.45;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    transition: background-color 0.4s ease, color 0.4s ease,
        border-color 0.4s ease, opacity 0.4s ease, box-shadow 0.4s ease;
}
.paylane-node.is-done {
    opacity: 1;
    background: rgba(0, 190, 165, 0.14);
    border-color: rgba(0, 190, 165, 0.55);
    color: #00bea5;
}
.paylane-node.is-active {
    opacity: 1;
    background: #00bea5;
    border-color: #00bea5;
    color: #fff;
    animation: paylane-pulse 2.2s ease-out infinite;
}
.paylane-link {
    flex: 1 1 auto;
    max-width: 60px;
    height: 2px;
    margin: 0 8px;
    border-top: 2px dashed rgba(0, 190, 165, 0.35);
    position: relative;
    overflow: visible;
    opacity: 0.45;
    transition: opacity 0.4s ease, border-color 0.4s ease, border-top-style
        0.4s;
}
.paylane-link.is-done {
    opacity: 1;
    border-top-style: solid;
    border-top-color: rgba(0, 190, 165, 0.6);
}
.paylane-link.is-running {
    opacity: 1;
}
.paylane-dot {
    display: none;
    position: absolute;
    top: -4px;
    right: 0;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #00bea5;
}
.paylane-link.is-running .paylane-dot {
    display: block;
    animation: paylane-drift 2.4s linear infinite;
}
@keyframes paylane-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(0, 190, 165, 0.45);
    }
    70% {
        box-shadow: 0 0 0 12px rgba(0, 190, 165, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(0, 190, 165, 0);
    }
}
@keyframes paylane-drift {
    0% {
        right: 0;
        opacity: 0;
    }
    15% {
        opacity: 1;
    }
    85% {
        opacity: 1;
    }
    100% {
        right: calc(100% - 6px);
        opacity: 0;
    }
}
@media (max-width: 576px) {
    .login-paylane {
        width: 85%;
        margin-top: 22px;
    }
    .paylane-node {
        width: 38px;
        height: 38px;
    }
    .paylane-link {
        max-width: 40px;
        margin: 0 5px;
    }
}
@media (prefers-reduced-motion: reduce) {
    .paylane-node.is-active,
    .paylane-link.is-running .paylane-dot {
        animation: none;
    }
}
</style>
